import Lenis from '@studio-freight/lenis'
import { isMobile, isInViewport, svgAnimation } from "./common.js";

const lenis = new Lenis({
    // lerp: 0.1,
    duration: 1.3,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    touchMultiplier: 1,
    wheelMultiplier: 0.5
})


const AboutPage = document.querySelector('.About_Page')
const hobbyContainer = document.querySelector(".About_Hobby_Container");

if (AboutPage) {
    const aboutImgLeft = document.querySelector(".aboutImg01");
    const aboutImgRight = document.querySelector(".aboutImg02");
    const cards = document.querySelectorAll('.Card_Wrapper')
    const hobby01 = document.querySelector(".hobby01");
    const hobby02 = document.querySelector(".hobby02");
    const hobby03 = document.querySelector(".hobby03");
    const hobbyBottom = hobbyContainer.getBoundingClientRect().bottom;
    let lenisScroll

    lenis.on('scroll', ({ scroll }) => {
        lenisScroll = scroll

        cards.forEach(card => {
            const rect = card.getBoundingClientRect();
            const cardTop = rect.top + lenisScroll;

            const centerY = cardTop - 250;

            let translateAmount = (centerY - lenisScroll - window.innerHeight / 2)
            let rotateAmount = -(centerY - lenisScroll - window.innerHeight / 2) * 0.01

            if (card.classList.contains('aboutImg01')) {
                card.style.transform = `translate3d(0, -${(-5) + translateAmount * -0.06}%, 0) rotate(-${2 + (rotateAmount * 0.6)}deg)`;
            }

            if (card.classList.contains('aboutImg02')) {
                card.style.transform = `translate3d(0, -${(-5) + translateAmount * -0.04}%, 0) rotate(${8 - (rotateAmount * 0.8)}deg)`;
            }

            if (lenisScroll > hobbyBottom) {
                aboutImgLeft.style.transform = `translate3d(0, -20%, 0) rotate(-10deg)`;
                aboutImgRight.style.transform = `translate3d(0, -20%, 0) rotate(0deg)`;
            }

            if (isInViewport(hobbyContainer)) {
                if (card.classList.contains('hobby01') || card.classList.contains('hobby02') || card.classList.contains('hobby03')) {
                    hobby01.style.transform = `translate3d(-${translateAmount * -0.05}%, -${translateAmount * -0.04}%, 0) rotate(-${10 + (rotateAmount * 1.2)}deg)`;
                    hobby02.style.transform = `translate3d(0, -${translateAmount * -0.06}%, 0)`;
                    hobby03.style.transform = `translate3d(${translateAmount * -0.05}%, -${translateAmount * -0.04}%, 0) rotate(${10 + (rotateAmount * 1.2)}deg)`;

                    if (isMobile()) {
                        hobby01.style.transform = `translate3d(-${translateAmount * -0.08}%, -${translateAmount * -0.04}%, 0) rotate(-${10 + (rotateAmount * 1.2)}deg)`;
                        hobby03.style.transform = `translate3d(${translateAmount * -0.08}%, -${translateAmount * -0.04}%, 0) rotate(${10 + (rotateAmount * 1.2)}deg)`;
                    }
                }
            }
        })
    })
}


const triggerContainer = document.querySelectorAll(".trigger");
let opt = {
    root: null,
    rootMargin: "-25% 0%",
    threshold: 0
}

let Observer = new IntersectionObserver(callback, opt);
triggerContainer.forEach(e => {
    Observer.observe(e);
})

function callback(entries) {
    let targetTxt, arrowAnimate, lineAnimate
    const targetClasses = ['about', 'goal']
    entries.forEach(entry => {
        if (entry.isIntersecting) {

            let arrowTrigger = entry.target.querySelector('.Arrow_Wrapper')
            if (arrowTrigger) {
                arrowAnimate = [...arrowTrigger.querySelectorAll('#path')]
                svgAnimation(arrowAnimate)
            }

            let lineTrigger = entry.target.querySelector('.Line_Wrapper')
            if (lineTrigger) {
                lineAnimate = [...lineTrigger.querySelectorAll('#underline')]
                setTimeout(() => {
                    svgAnimation(lineAnimate)
                }, 500);
            }

            targetTxt = entry.target.querySelector('.Lead_txt')
            if (!targetTxt) {
                return
            } else {
                for (let i = 0; i < targetClasses.length; i++) {
                    if (targetTxt.classList.contains(targetClasses[i])) {
                        targetTxt.dataset.change = 'true'
                        changeFontsize(targetTxt);
                    }
                }
            }

        } else {
            window.removeEventListener("wheel", wheel);
            window.removeEventListener("touchmove", move);
        }
    })
}

let sum = 0;
let prevMove = 0;
let nextMove = 0;
let prevStamp = 0;
let nextStamp = 0;

function move(e) {
    let currentMove = e.touches[0].clientY;
    let currentStamp = e.timeStamp;

    if (prevStamp == 0) {
        prevStamp = currentStamp;
    } else {
        nextStamp = currentStamp;
        if (nextStamp - prevStamp > 100) {
            prevMove = 0;
        }
        prevStamp = currentStamp;
    }

    if (prevMove == 0) {
        prevMove = currentMove;
    } else {
        nextMove = currentMove;
        sum = sum + (prevMove - nextMove);
        prevMove = currentMove;
    }
}

function wheel(e) {
    sum = sum + e.deltaY;
}

function changeFontsize(ele) {
    if (!isMobile()) {
        if (sum > 0 && sum < 1000) {
            ele.style.fontSize = `100px`;
        } else if (sum >= 1000) {
            sum = 1000;
            ele.style.fontSize = `100px`;
        } else if (sum <= 0) {
            sum = 0;
            ele.style.fontSize = `100px`;
        } else {
            return
        }
    } else {
        if (sum > 0 && sum < 550) {
            ele.style.fontSize = `50px`;
        } else if (sum >= 550) {
            sum = 550;
            ele.style.fontSize = `50px`;
        } else if (sum <= 0) {
            sum = 0;
            ele.style.fontSize = `50px`;
        } else {
            return
        }
    }
}


/**
 * Skill lists
 */
const SkillLists = [...document.querySelectorAll('.Skill_Lists li')]
SkillLists.forEach((e) => {
    let delay = e.dataset.delay
    e.style.transitionDelay = `${delay}00ms`
})


/**
 * Work experience accordion
 */
const resize = (target) => {
    let timeoutID = 0;
    let delay = 500;

    window.addEventListener("resize", () => {
        let data = target.dataset.open

        // Keep clearing the process while resizing.
        clearTimeout(timeoutID);

        timeoutID = setTimeout(() => {
            let h = target.children[1].children[0].clientHeight // height of accordion_contents > ul

            if (data === 'true') {
                target.children[1].style.height = `${h}px`
            }
        }, delay);
    }, false);
};

const accordionBtns = [...document.querySelectorAll('.Accoordion_Btn')]
accordionBtns.forEach((i) => {
    const openedItem = i.parentElement;
    let accordionContents = i.nextElementSibling;

    if (openedItem.dataset.open === 'true') {
        setTimeout(() => {
            const contentsHeight = accordionContents.children[0].clientHeight;
            accordionContents.style.height = `${contentsHeight}px`;
        }, 500);
    }

    i.addEventListener('click', (e) => {
        e.preventDefault()
        let closestItem = e.target.closest('.Accordion_Item');
        let itemHeight = accordionContents.children[0].clientHeight;

        if (closestItem.dataset.open === "false") {
            closestItem.dataset.open = "true";
            accordionContents.style.height = `${itemHeight}px`;
        } else {
            closestItem.dataset.open = "false";
            accordionContents.style.height = `0px`;
        }
    })

    resize(openedItem);
})

function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
}
requestAnimationFrame(raf)
